module.exports = __webpack_public_path__ + "img/storeNum1.7ea2cbc2.png";